// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

export const SHIFTS_ENTITY_SETS = 'shifts.entitySets'
export const AGENCY_SHIFTS_ENTITY_SETS = 'agencyShifts.entitySets'
// Key used to store our data in localStorage.
export const keyPrefix = `flex.`
// Cross-tab idle timestamp, written straight to localStorage by the idle-timeout
// saga rather than through redux-persist. It shares the keyPrefix but is not a
// reducer slice, so the persistence sweep has to treat it as reserved.
export const userActiveKey = `${keyPrefix}user_last_active_at`
export const listingShiftBreakTypes = {
  deleted: 'delete_break',
  clocked: 'clock_break',
}
export const CERT = 'certification'
export const LEGAL = 'legal compliance'
export const CLIENT = 'client compliance'
